import React from "react";
import { Switch, BrowserRouter, Route, Link, Redirect } from "react-router-dom";

import Business from "./Business/index";
import ViewEquipment from "./ViewEquipment";
import ViewShop from "./ViewShop";
const Router = ({ match }) => {
  return (
    <React.Fragment>
      <Route
        path={`${match.path}`}
        exact
        render={() => <Redirect to="/tenant/business"></Redirect>}
      ></Route>
      <Route exact path={`${match.path}/tenant`} component={Business}></Route>
      <Route
        path={`${match.path}/viewequipment/:id`}
        component={ViewEquipment}
      ></Route>
      <Route
        path={`${match.path}/tenant/viewShop/:id`}
        component={ViewShop}
      ></Route>
    </React.Fragment>
  );
};
export default Router;
